import { post,get } from "../ajax";

interface saveCustomerServiceType{
    id: number,
    userName: string,
    password: string,
    mobile: string,
    disable: boolean
}

export async function customerServiceList(body:Record<string, any>){
    const url = `/api/CustomerService/GetCustomerServicePageList?UserName=${body.UserName}&Mobile=${body.Mobile}&PageIndex=${body.PageIndex}&PageSize=${body.PageSize}`
    const res = await get(url)
    return res;
}

export async function saveCustomerService(body:saveCustomerServiceType){
    const url = `/api/CustomerService/SaveCustomerServiceAccount`
    const res = await post(url,body)
    return res;
}

export async function changeCustomerService(body:{id:number,disable:boolean}){
    const url = `/api/CustomerService/DisableOrEnableAccount`
    const res = await post(url,body)
    return res;
}

export async function unrelatedMerchant(body:{Name:string,PageIndex:number,PageSize:number,AccountId:number}){
    const url = `/api/CustomerService/GetRelatedMerchantPagelist?Name=${body.Name}&PageIndex=${body.PageIndex}&PageSize=${body.PageSize}&AccountId=${body.AccountId}`
    const res = await get(url)
    return res;
  }

export async function cusRelatedMerchant(body:{accountId:number,merchantIds:number[]}){
    const url = `/api/CustomerService/RelatedMerchant`
    const res = await post(url,body)
    return res;
}